import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import brainImage from '../assets/brain-imaginem.png';
import './Login.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/';

  if (user) {
    return <Navigate to={from} replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const cleanEmail = email.trim();
    console.log('[Login] Initiating login attempt for user:', cleanEmail);
    try {
      await login(cleanEmail, password);
      console.log('[Login] Login successful! Navigating to:', from);
      navigate(from, { replace: true });
    } catch (err) {
      console.error('[Login] Login failed:', err);
      setError(err.message || 'Error al iniciar sesión');
    }
  };

  return (
    <div className="loginPage">
      {/* 1. IMAGEN COMO FONDO GLOBAL */}
      <img 
        src={brainImage} 
        className="brain-image" 
        alt="Fondo Cerebro" 
        onError={(e) => { e.target.style.display = 'none'; }} 
      />

      {/* Background Pattern */}
      <div className="bg-pattern"></div>

      {/* Main Content Container */}
      <div className="login-container-grid">
        {/* Left Top Text */}
        <div className="header-text">
          <h1>GEMA</h1>
          <p>EL PORTAL CORPORATIVO<br />DE IMAGINEM RADIOLOGIA</p>
        </div>

        {/* Right Bottom Login Box */}
        <div className="login-box-wrapper">
          <div className="glass-panel">
            <h4>IDENTIFÍCATE PARA ACCEDER</h4>

            <form onSubmit={handleSubmit} className="login-form">
              <div className="input-group">
                <i className="fa-regular fa-user"></i>
                <input
                  type="text"
                  placeholder="Email corporativo"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              <div className="input-group">
                <i className="fa-solid fa-key"></i>
                <input
                  type="password"
                  placeholder="Contraseña"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              {error && (
                <div style={{ color: '#ff8a8a', fontSize: '0.8rem', marginTop: '0.5rem', fontWeight: 500 }}>
                  {error}
                </div>
              )}

              <button type="submit" className="btn-login">INGRESAR</button>

              <a href="#" className="forgot-password">Olvidé mi contraseña</a>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
